import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { Box, HStack } from '@chakra-ui/react'
import {
  faCalendarDays,
  faCheckCircle,
} from '@fortawesome/free-regular-svg-icons'
import { faDollarSign, faUserCheck } from '@fortawesome/free-solid-svg-icons'
import { format, parse } from 'date-fns'
import Toast from '../Toast/Toast'
import RefillsIndicator from '../Toast/ToastContents/RefillsIndicator/RefillsIndicator'
import IconButton from '../IconButton/IconButton'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import { numberFormat } from '../../utils/formats/formats'

function RefillsIndicatorsList({
  disponibleAmount = '',
  lastRecharge = '',
  lastRechargeAmount = '',
  iconColor = '',
}) {
  const { texts } = useLabels()

  // El Header es el único responsable del selector, modal y navegación.
  const goToNewRecharge = useCallback(() => {
    window.dispatchEvent(
      new CustomEvent('company-survey:navigate', {
        detail: { to: '/refills/new' },
      }),
    )
  }, [])

  const rechargeDate = useMemo(() => {
    if (lastRecharge) {
      const date = parse(lastRecharge, 'dd-MM-yyyy', new Date())
      return format(date, 'MMM dd, yyyy')
    }
    return ''
  }, [lastRecharge])

  return (
    <HStack spacing="27px" w="100%">
      <Toast width="150px">
        <RefillsIndicator
          iconColor={iconColor}
          icon={faDollarSign}
          label={texts.available_balance}
          subLabel={numberFormat(disponibleAmount, 'currency')}
        />
      </Toast>
      <Toast>
        <RefillsIndicator
          iconColor={iconColor}
          icon={faCalendarDays}
          label={texts.last_recharge}
          subLabel={lastRecharge ? rechargeDate : 'Sin información'}
        />
      </Toast>
      <Toast>
        <RefillsIndicator
          iconColor={iconColor}
          icon={faUserCheck}
          label={texts.last_recharge_amount}
          subLabel={
            lastRechargeAmount
              ? numberFormat(lastRechargeAmount, 'currency')
              : 'Sin información'
          }
        />
      </Toast>
      <Box h="7.2vh">
        <IconButton
          onClick={goToNewRecharge}
          text={texts.new_recharge}
          icon={faCheckCircle}
        />
      </Box>
    </HStack>
  )
}

RefillsIndicatorsList.propTypes = {
  disponibleAmount: PropTypes.string,
  iconColor: PropTypes.string,
  lastRecharge: PropTypes.string,
  lastRechargeAmount: PropTypes.string,
}

export default RefillsIndicatorsList
